import { Column } from "components/Table/Simple";
import { formatDateTime, truncate } from "components/Table/Simple/presets";
import numeral from "numeral";

export const columns: Column[] = [
    {
        label: "ID",
        field: "id",
    },
    {
        label: "의사명",
        field: "name",
        creatable: true,
        editable: true,
    },
    {
        label: "연혁",
        field: "description",
        render: (value, field, row) => truncate(value, 30),
        creatable: true,
        editable: true,
        textarea: true,
    },
    {
        label: "의원명",
        field: "clinic",
        render: (value, field, row) => row?.clinic?.name,
    },
    {
        label: "진료과목",
        field: "specialties",
        render: (value, field, row) => {
            return row.specialties.map((specialty: any) => specialty.name).join(", ");
        },
    },
    {
        label: "프로필 이미지",
        field: "profileImage",
        visible: false,
    },
    {
        field: "clinic_id",
        visible: false,
    },
    {
        field: "created_at",
        label: "생성일",
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        render: formatDateTime
    },
    {
        field: "averageRating",
        label: "평점",
        render: (value)=> numeral(value).format("0.00"),
    },
    {
        field: "reviewCount",
        label: "리뷰 수",
    },
    {
        field: "reviews",
        label: "리뷰",
        visible: false,
    }
];